import { Injectable, inject } from '@angular/core';
import { ServerRequestMessage } from '@app/enums/server-request';
import { WsService } from '@app/services/ws.service';

// Poll & Voting, see https://github.com/ElninhoConsulting/Html5V2/wiki/Poll-And-Voting
@Injectable({
  providedIn: 'root'
})
export class PollsService {
  private readonly _ws = inject(WsService);

  // server replies with CustomMessageType.PlayerPolls = 58
  getPlayersPolls(): void {
    this._ws.sendData({
      type: ServerRequestMessage.GetPlayersPolls
    });
  }

  // server replies with ServerMsgType.PlayerVoteResponse = 451
  vote(pollId: number, option: number): void {
    this._ws.sendData({
      type: ServerRequestMessage.PlayerVote,
      value: pollId,
      value2: option
    });
  }
}
